import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

    isOpen: boolean;

    @Input() title: string;
    @Input() description: any;

    @HostBinding('attr.tabindex') tabindex = '0';

    @HostListener('blur', ['$event.target']) onBlur(target): void {
        this.close();
    }


    constructor() {

        this.isOpen = false;
    }

    ngOnInit(): void {
    }

    public close(): void {
        this.isOpen = false;
    }

    public open(): void {
        this.isOpen = true;
    }

    public openClose(open: boolean): void {
        this.isOpen = open;
    }
}
